<template>
<div id="62" class="template" @click="nextScene">

   <div class="zone-01":style="zone1.style" :class="{scene2: currScene === 2}">
   </div>

   <div class="zone-02" >
      <img :style="getImageStyle(zone2)" :src="this.GALLERY_HOST + '/' + zone2.val" id="2000" >
   </div>
   <div class="zone-03" :class="{scene2: currScene === 2}">
      <h1 id="3000">{{zone3.val}}</h1>
   </div>

   <!-- <transition name="fade"> -->
      <!-- <div class="content-container" v-if="currScene === 2"> -->
      <div class="content-container">
         <div class="zone-04" id="4000">{{zone4.val}}</div>
      </div>
   <!-- </transition> -->

   <div class="media-wrapper" id='mwrap' :class="{scene2: currScene === 2}">
      <!-- Multimedia icons will only display on playout if content has been assigned to the Zones 
      onClick open modal with the corresponding asset -->
      <div v-if="zone5.val" class="zone-05">
         <div id="5000" class="zone-btn-wrapper" @click.stop="audio = true">Listen</div>
      </div>
      <div v-if="zone6.val" class="zone-06">
         <div id="6000" class="zone-btn-wrapper" @click.stop="video = true">Watch</div>
      </div>
      <div v-if="zone7.val" class="zone-07" >
         <div id='7000' class="zone-btn-wrapper" @click.stop="gallery = true">Gallery</div>
      </div>
      <div v-if="zone13.val" class="zone-13" >
         <div id='13000' class="zone-btn-wrapper" @click.stop="weblink = true">WebLink</div>
      </div>
      <div class="zone-07a">
         <div id='others_btn' class="zone-btn-wrapper">Others</div>
      </div>
   </div>

   <transition name="fade">
      <div class="zone-08" id="8000" v-if="currScene === 2" @click.stop="showScene3">
         {{zone8.val}}
      </div>
   </transition>

   <audio-overlay
      v-if="audio"
      :asset="getAsset('media', 5000)"
      @close="closeOverlay">
   </audio-overlay>

   <video-overlay
      v-if="video"
      :asset="getAsset('media', 6000)"
      @close="closeOverlay">
   </video-overlay>

   <gallery-overlay
      v-if="gallery"
      :asset="getAsset('media', 7000)"
      @close="closeOverlay">
   </gallery-overlay>

   <weblink-overlay
      v-if="weblink"
      :asset="getAsset('media', 13000)"
      @close="closeOverlay">
   </weblink-overlay>

   <scene3
      v-if="currScene === 3"
      :zone8="zone8"
      :zone9="zone9"
      :zone10="zone10"
      :zone11="zone11"
      :zone12="zone12"
      @close="currScene = 2">
   </scene3>
   
</div>
</template>

<script>
import AudioOverlay from './AudioOverlay';
import VideoOverlay from './VideoOverlay';
import GalleryOverlay from './GalleryOverlay';
import WeblinkOverlay from './WeblinkOverlay';
import Scene3 from './Scene3';

import BasePreview from './../BasePreview';

import 'jplayer';
import 'slick-carousel';

export default {
   extends: BasePreview,
   data() {
      return {
         currScene: 1,
         instanceRecid: '',
         zone1: {},
         zone2: {},
         zone3: {},
         zone4: {},
         zone5: {},
         zone6: {},
         zone7: {},
         zone8: {},
         zone9: {},
         zone10: {},
         zone11: {},
         zone12: {},
         zone13: {},
         audio: false,
         video: false,
         gallery: false,
         weblink: false,
         others: false
      }
   },

   props: {
      json: {}
   },

   computed: {
      zone2Style() {
         return 'top: ' + this.zone2.assetY + 'px; left: '+this.zone2.assetX+ 'px; width: '+ 1080 * this.zone2.scaleX +'px;';
      }
   },

   created() {
      this.assignZones();
   },

   methods: {

      assignZones() {
         this.zone1 = this.getAsset('media', 1000);
         this.zone2 = this.getAsset('media', 2000);
         this.zone3 = this.getAsset('text', 3000);
         this.zone4 = this.getAsset('text', 4000);
         this.zone5 = this.getAsset('media', 5000);
         this.zone6 = this.getAsset('media', 6000);
         this.zone7 = this.getAsset('media', 7000);
         this.zone8 = this.getAsset('text', 8000);
         this.zone9 = this.getAsset('media', 9000);
         this.zone10 = this.getAsset('media', 10000);
         this.zone11 = this.getAsset('media', 11000);
         this.zone12 = this.getAsset('media', 12000);
         this.zone13 = this.getAsset('media', 13000);
      },

      getAsset(type, id) {
         let result;
         if (type === 'media') {
            result = this.json.tmpl.assets.filter(obj => {
               return obj.id === id;
            });
         } else {
            result = this.json.tmpl.data.text.filter(obj => {
               return obj.id === id;
            });
         }
         if (result) {
            return result[0];
         } else {
            return null;
         }
      },

      overlayUp() {
         return this.audio || this.video || this.gallery || this.others || this.currScene === 3;
      },

      nextScene() {
         if (!this.overlayUp()) {
            this.currScene = 2;
         }
      },

      showScene3() {
         this.currScene = 3;
      },
      
      closeOverlay() {
         this.audio = false;
         this.video = false;
         this.gallery = false;
         this.weblink = false;
         this.others = false;
      }
   },

   watch: {
      currScene() {
         if (this.currScene == 2) {
            $('.zone-04').addClass('scene2');
         }
      }
   },

   components: {
      AudioOverlay,
      VideoOverlay,
      GalleryOverlay,
      WeblinkOverlay,
      Scene3
   }
}
</script>

<style lang="scss" scoped>
.template {
   background: #000;
   overflow: hidden;
   position: relative;
   height: 1920px;
   width: 1080px;
   // max-width: 100%;
   // max-height: 100%;
   overflow: hidden;
   z-index: 1;
   margin: 0 auto;
   transform: scale(.45);
}

.zone-01 {
   position: absolute;
   pointer-events: none;
}
.zone-01,
.zone-02 {
   height: 1920px;
   width: 1080px;
}
.zone-02 {
   position: relative;

   &.scene2 {
      img {
         // transition: opacity 0.3s;
         // -webkit-transition: opacity 0.3s;
         // opacity: .3;
      }
   }
}
.zone-01 img {
   max-width: 100%;
   max-height: 100%;
}

.zone-01 {
   z-index: 1;
   opacity: .5;

   &.scene2 {
      transition: opacity 1s;
      -webkit-transition: opacity 1s;
      opacity: .8;
   }
}

.zone-02 img {
   max-width: unset;
}
.zone-01 img,
.zone-02 img {
   position: absolute;
   top: 0;
   left: 0;
}

/* Text title field */
.zone-03 {
   position: absolute;
   top: 90%;
   z-index: 2;
   text-align: center;
   width: 100%;
   transition: top 1s linear;

   &.scene2 {
      top: 34%;
   }
}
.zone-03 h1 {
   line-height: 79px;
   font-weight: 700;
   font-size: 79px;
   color: #fff;
   text-transform: uppercase;
}

/* Description Text Field  Max # of lines: 12 */
.zone-04 {
   position: absolute;
   width: 670px;
   max-height: 670px;
   margin-right: 18%;
   overflow: hidden;
   top: -1000px;
   white-space: pre-wrap;
   overflow-wrap: break-word;
   opacity: 0;
   transition: opacity 1s;
   transition-delay: 1s;

   &.scene2 {
      opacity: 1;
   }
}
.zone-04 {
   margin-bottom: 45px;
   line-height: 45px;
   font-size: 35px;
   color: #000;
}

.content-container {
  margin: 0 5%;
  position: relative;
  z-index: 2;
}
.content-container > div {
  display: inline-block;
  vertical-align: top;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
  transition-delay: 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* Buttons on the right */
.media-wrapper {
  width: 15%;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  position: absolute;
  top: 0;
  right: 5%;
  visibility: hidden;
  z-index: 2;
  transition: top 1s linear;

  &.scene2 {
     visibility: visible;
     top: 800px;
  }

   .zone-btn-wrapper {
      width: 100px;
      height: 100px;
      margin-bottom: 70px;
      padding: 50px 0 0 0;
      background-color: transparent;
      background-repeat: no-repeat;
      background-position: center top;
      background-size: 100px 100px;
      font-size: 25px;
      color: #fff;
   }
}

/* Listen */
.zone-05 .zone-btn-wrapper {
  padding: 95px 0 0 0;
  background-size: 111px 92px;
  background-image: url('./assets/icons/bttn-listen.svg');
}
.zone-06 .zone-btn-wrapper {
  padding: 95px 0 0 0;
  background-size: 111px 92px;
  background-image: url('./assets/icons/bttn-video.svg');
}
.zone-07 .zone-btn-wrapper {
  padding: 95px 0 0 0;
  background-size: 111px 92px;
  background-image: url('./assets/icons/bttn-gallery.svg');
}
.zone-07a .zone-btn-wrapper {
  padding: 95px 0 0 0;
  background-size: 107px 91px;
  background-image: url('./assets/icons/bttn-others.svg');
}
.zone-13 .zone-btn-wrapper {
  padding: 95px 0 0 0;
  background-size: 103px 81px;
  background-image: url('./assets/icons/weblink.svg');
}

.zone-btn-wrapper {
  text-transform: uppercase;
}

.zone-08 {
  margin: 0 5%;
  font-weight: 400;
  font-size: 25px;
  color: #fff;
  z-index: 2;
  position:absolute;
  bottom: 135px;
}
.zone-08 a {
  text-decoration: none;
}

// @keyframes zone-01 {
// 	from {
// 		filter: brightness(1);
// 		filter: opacity(1);
// 		-webkit-filter: brightness(1);
// 		-webkit-fitler: opacity(1);
// 	}
// 	to {
// 		filter: brightness(1);
// 		filter: opacity(0.65);
// 		-webkit-filter: brightness(1);
// 		-webkit-filter: opacity(0.65);
// 	}
// }

// @keyframes zone-02 {
// 	0% {
// 		filter: brightness(1);
// 		filter: opacity(0);
// 		-webkit-filter: brightness(1);
// 		-webkit-filter: opacity(0);
// 	}
// 	50% {
// 		filter: brightness(0.45);
// 		filter: opacity(1);
// 		-webkit-filter: brightness(0.45);
// 		-webkit-filter: opacity(1);
// 	}
// 	100% {
// 		filter: brightness(0.5);
// 		filter: opacity(0.35);
// 		-webkit-filter: brightness(0.5);
// 		-webkit-filter: opacity(0.5);
// 	}
// }

@keyframes zone-03 {
	from {
		opacity: 0
	}
	to {
		opacity: 1
	}
}

</style>
